'use strict';
var angular = require('angular');
var GeneralInfoService = /** @class */ (function () {
    function GeneralInfoService($http) {
        'ngInject';
        this._$http = $http;
        // Object to store our user properties
        this.current = null;
    }
    GeneralInfoService.prototype.handleSuccess = function (response) {
        return response;
    };
    GeneralInfoService.prototype.handleError = function (response) {
        return response;
    };
    GeneralInfoService.prototype.getRegions = function () {
        var request = this._$http({
            method: 'GET',
            url: 'api/admin/regions',
            params: {
                action: 'get'
            }
        });
        return (request.then(this.handleSuccess, this.handleError));
    };
    GeneralInfoService.prototype.getRegionsForCountry = function (countryCode) {
        var request = this._$http({
            method: 'GET',
            url: "api/admin/regions/" + countryCode,
            params: {
                action: 'get'
            }
        });
        return (request.then(this.handleSuccess, this.handleError));
    };
    GeneralInfoService.prototype.getCountries = function () {
        var request = this._$http.get('api/admin/countries');
        return (request.then(this.handleSuccess, this.handleError));
    };
    GeneralInfoService.prototype.getReferralSources = function () {
        var request = this._$http.get('api/admin/referralSources');
        return (request.then(this.handleSuccess, this.handleError));
    };
    GeneralInfoService.prototype.getLandingPageName = function (cpid) {
        var request = this._$http.get("api/content/page/" + cpid);
        return (request.then(this.handleSuccess, this.handleError));
    };
    GeneralInfoService.prototype.checkEmailAccountExists = function (email) {
        var request = this._$http.get("api/account/" + email);
        var accountExists = true;
        return (request.then(function (data) {
            if (data.status == 200) {
                // May be specifically check for status code of 200
                // and if customerId is not null to determine if account exists or not?
                if (data.data.errors.length > 0) {
                    accountExists = false;
                }
                if (data.data.response == true) {
                    accountExists = true;
                }
                else {
                    accountExists = false;
                }
                return (accountExists);
            }
            return (false);
        }, function (err) {
            if (err.status == 400 || err.status == 404) {
                // Maybe specifically check for status code of 400 or 404
                // to determine if account doesn't exist?
            }
            return (false);
        }));
    };
    return GeneralInfoService;
}());
export default GeneralInfoService;
//# sourceMappingURL=general-info.service.js.map